// Real image assets — the production source of truth.
// Files live in src/assets/ and are registered here by storage key.

import entryProfile from "./entry-profile.jpg";
import langhomePortrait from "./langhome-portrait.webp";
import visionStage from "./vision-stage.webp";
import aboutPortrait from "./about-portrait.jpg";
import aboutConference from "./about-conference.jpg";
import aboutBlockchainPanel from "./about-blockchain-panel.jpg";
import aboutAward from "./about-award.jpg";
import aboutRooftop from "./about-rooftop.jpg";
import aboutTravel from "./about-travel.jpg";
import logoNasa from "./logo-nasa.webp";
import logosFooter from "./logos-footer.webp";
import flagSr from "./flag-sr.webp";
import flagIt from "./flag-it.webp";
import flagEn from "./flag-en.webp";

export const IMAGES = {
  "entry-profile": entryProfile,
  "langhome-portrait": langhomePortrait,
  "vision-stage": visionStage,
  "about-portrait": aboutPortrait,
  "about-conference": aboutConference,
  "about-blockchain-panel": aboutBlockchainPanel,
  "about-award": aboutAward,
  "about-rooftop": aboutRooftop,
  "about-travel": aboutTravel,
};

// Brand assets used outside the photo slots.
export const LOGO_NASA = logoNasa;
export const LOGOS_FOOTER = logosFooter;
export const FLAGS = { sr: flagSr, it: flagIt, en: flagEn };
